//Wrap the global Image() method because it clashes with GoFormz  Image class
export default class ImageProxy {
  static getImageObject() {
    return new Image();
  }
}
